exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".staticLayoutContentWrapper--CCKGy {\r\n\tpadding: 72px 0 !important;\r\n}\r\n", ""]);

// Exports
exports.locals = {
	"staticLayoutContentWrapper": "staticLayoutContentWrapper--CCKGy"
};